import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from 'dayjs';
import "./Steps.css";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import CheckIcon from '@mui/icons-material/Check';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';

import { sendAppointment } from "../../../redux/actions/dataActions";
import { useT } from "../../../i18n";

function Step5(props) {
     console.log("step 5 start");
  const t = useT();
  const location = useLocation();
  const {user} = useSelector((state) => state.auth)
  const {loading} = useSelector((state) => state.async)
  const navigate = useNavigate();
  const { success_visitor } = useSelector((state) => state.data)
  const { failed_visitor } = useSelector((state) => state.data)
  const dispatch = useDispatch();
  const department = user?.departments.find(d => d.id == props.formData.department_id)

  const Next = () => {

    dispatch(sendAppointment(props.formData))
  }
 
  return (
    <div className="step step5">
        <h5>{t("step5.title")}</h5>
        <Card className="s5-card">
          <div className="s5-provider">
            <span className="s5-dept">{department?.title}</span>
            {props?.formData?.doctor?.title && (
              <><span className="s5-sep">·</span><span className="s5-service">{props.formData.doctor.title}</span></>
            )}
          </div>
          {props?.formData?.doctor?.address && (
            <div className="s5-address"><LocationOnRoundedIcon fontSize="small" /> {props.formData.doctor.address}</div>
          )}
          <div className="s6-dt s5-dt">
            <div className="s6-dt-box"><span>{t("common.date")}</span><b>{dayjs(props.formData.timeData.wdate).format('DD/MM/YYYY')}</b></div>
            <div className="s6-dt-box"><span>{t("common.time")}</span><b>{props.formData.timeData.start_time.slice(0,-3)}</b></div>
          </div>
        </Card>

        <LoadingButton 
        variant="contained" 
        loading={loading}
        className="next-btn send_b" 
        onClick={Next}
        endIcon={<CheckIcon />}
        >{t("step5.confirmAppointment")}</LoadingButton>
        
    </div>
  );
}

export default Step5;
